import React from 'react';
import {
  //LocalOffer as LocalOfferIcon,
  Dashboard as DashboardIcon,
  Person as ProfileIcon,
  //Notifications as NotificationsIcon,
  Security as SecurityIcon,
  List as MuiListIcon,
  FormatListBulleted as FormatListBulletedIcon,
  Apps as AppsIcon,
  Window as WindowIcon,
  Filter as CollectionIcon,
  X,
  Instagram,
  Language,
  SquareRounded as LargeBoxIcon,
  LocalFireDepartment as BurnIcon,
  StarBorder,
  HorizontalSplit as ItemsIcon,
  TrendingUp as AnalyticsIcon,
  SyncAlt as ActivityIcon,
  People as HoldersIcon,
  AccessTime as AccessTimeIcon,
  Add as CreateIcon,
  School as LearnIcon,
} from '@mui/icons-material';
import { PiGavelFill as BidsIcon } from 'react-icons/pi';

import { Link, Box, styled } from '@mui/material';

import { reservoirChains } from '@reservoir0x/reservoir-sdk';

import {
  MenuDiscordIcon,
  MenuTwitterIcon,
  MenuInstagramIcon,
  MenuRedditIcon,
  MenuYouTubeIcon,
  OfferIcon,
  TransferIcon,
  MintedIcon,
  SaleIcon,
  ListIcon,
  BidIcon,
  DiscordNewIcon,
  MetamaskIcon,
  CoinBaseIcon,
  NRGChromeIcon,
  EthNewIcon,
  ApeChainSymbolNew,
  BerachainSymbolNew,
  BaseSymbol,
  SoneiumSymbol,
  AbstractSymbol,
  ShibariumSymbolNew,
  TenSymbol,
  MonadSymbol,
} from 'components/ImageComponent';
import { Profile, /*Notifications,*/ /*Offers,*/ AccountSupport } from 'pages/Settings/components';
import MyCollections from 'pages/Settings/components/MyCollections';

export const APP_VERSION = 'v3.0.0';

// Width for Filter side bar drawer
export const DRAWER_WIDTH = '360px';

export const ENERGI_SUPPORT_LINK =
  'https://discord.com/channels/398355554172534805/1157987899246137384';

const LINK_GMI_DOCS = 'https://docs.gonnamakeit.com/';

// closing time after leave menu
export const MENU_CLOSING_TIME = 100;

export const SIGNATURE_EXPIRY_TIME = 604800000; // 7 days

export const BUILD_MODE = process.env.REACT_APP_BUILD_MODE;

export const CONFIG = {
  Testnet: {
    ETHEREUM_CHAIN_ID: 11155111,
    ENERGI_CHAIN_ID: 49797,
    APECHAIN_CHAIN_ID: 33111,
    BERACHAIN_CHAIN_ID: 80069,
    SONEIUM_CHAIN_ID: 1946,
    ABSTRACT_CHAIN_ID: 11124,
    SHIBARIUM_CHAIN_ID: 157,
    TEN_CHAIN_ID: 443,
    MONAD_CHAIN_ID: 10143,
    ENERGI_LAUNCHPAD: 'https://launchpad.test.gonnamakeit.com/',
    BASE_CHAIN_ID: 84532,
  },
  Mainnet: {
    ETHEREUM_CHAIN_ID: 1,
    ENERGI_CHAIN_ID: 39797,
    APECHAIN_CHAIN_ID: 33139,
    BERACHAIN_CHAIN_ID: 80094,
    SONEIUM_CHAIN_ID: 1868,
    ABSTRACT_CHAIN_ID: 2741,
    SHIBARIUM_CHAIN_ID: 109,
    TEN_CHAIN_ID: 999, // TODO: Replace with actual TEN mainnet chain ID
    MONAD_CHAIN_ID: 999, // TODO: Replace with actual Monad mainnet chain ID
    ENERGI_LAUNCHPAD: 'https://launchpad.gonnamakeit.com/',
    BASE_CHAIN_ID: 8453,
  },
};

export const SUPPORTED_NETWORKS = {
  Energi: CONFIG[BUILD_MODE].ENERGI_CHAIN_ID,
  Ethereum: CONFIG[BUILD_MODE].ETHEREUM_CHAIN_ID,
  ApeChain: CONFIG[BUILD_MODE].APECHAIN_CHAIN_ID,
  Berachain: CONFIG[BUILD_MODE].BERACHAIN_CHAIN_ID,
  Base: CONFIG[BUILD_MODE].BASE_CHAIN_ID,
  Soneium: CONFIG[BUILD_MODE].SONEIUM_CHAIN_ID,
  Abstract: CONFIG[BUILD_MODE].ABSTRACT_CHAIN_ID,
  Shibarium: CONFIG[BUILD_MODE].SHIBARIUM_CHAIN_ID,
  Ten: CONFIG[BUILD_MODE].TEN_CHAIN_ID,
  Monad: CONFIG[BUILD_MODE].MONAD_CHAIN_ID,
};

const NETWORK_TO_COIN_MAP = {
  Energi: {
    Symbol: 'NRG',
    Name: 'Energi',
  },
  Ethereum: {
    Symbol: 'ETH',
    Name: 'Ether',
  },
  Base: { Symbol: 'ETH', Name: 'Ether' },
  ApeChain: {
    Symbol: 'APE',
    Name: 'ApeChain',
  },
  Berachain: {
    Symbol: 'BERA',
    Name: 'Berachain',
  },
  Soneium: {
    Symbol: 'ETH',
    Name: 'Ether',
  },
  Abstract: {
    Symbol: 'ETH',
    Name: 'Ether',
  },
  Shibarium: {
    Symbol: 'BONE',
    Name: 'Shibarium',
  },
  Ten: {
    Symbol: 'ETH',
    Name: 'Ether',
  },
  Monad: {
    Symbol: 'MON',
    Name: 'Monad',
  },
};

export const DEFAULT_NETWORK = SUPPORTED_NETWORKS.Ethereum;
export const CHAIN_ID = parseInt(DEFAULT_NETWORK);
export const COIN = NETWORK_TO_COIN_MAP[process.env.REACT_APP_NETWORK_NAME];

export const DEFAULT_LAUNCHPAD = CONFIG[BUILD_MODE].ENERGI_LAUNCHPAD;

// All links within marketplace and outside - handle testnet/mainnet in env?
export const LINKS_LIST = {
  allNFTs: {
    name: 'All NFTs',
    link: '',
  },
  new: {
    name: 'New',
    link: '',
  },
  art: {
    name: 'Art',
    link: '',
  },
  domainNames: {
    name: 'Domain Names',
    link: '',
  },
  virtualWorlds: {
    name: 'Virtual Worlds',
    link: '',
  },
  tradingCards: {
    name: 'Trading Cards',
    link: '',
  },
  collectibles: {
    name: 'Collectibles',
    link: '',
  },
  sports: {
    name: 'Sports',
    link: '',
  },
  utility: {
    name: 'Utility',
    link: '',
  },
  profile: {
    name: 'Profile',
    link: '',
  },
  favorites: {
    name: 'Favorites',
    link: '',
  },
  myCollectibles: {
    name: 'My Collectibles',
    link: '',
  },
  settings: {
    name: 'Settings',
    link: '',
  },
  rankings: {
    name: 'Rankings',
    link: '',
  },
  activity: {
    name: 'Activity',
    link: '',
  },
  blog: {
    name: 'Blog',
    link: '',
  },
  partners: {
    name: 'Partners',
    link: '',
  },
  website: {
    name: 'Website',
    type: 'resources',
    link: '',
  },
  documentation: {
    name: 'Docs',
    link: '',
  },
  github: {
    name: 'Github',
    link: 'https://github.com/energicryptocurrency',
    external: true,
  },
  joinOurTeam: {
    name: 'Join Our Team',
    link: 'https://www.energi.world/join-our-team/',
    external: true,
  },
  contactUs: {
    name: 'Contact Us',
    link: ENERGI_SUPPORT_LINK,
    external: true,
  },
  twitter: {
    name: 'Twitter',
    link: 'https://x.com/gonnamakeitnfts',
    external: true,
  },
  discord: {
    name: 'Discord',
    link: 'https://discord.com/invite/sCtgNC3/',
    external: true,
  },
  telegram: {
    name: 'Telegram',
    link: 'https://t.me/GonnaMakeitNFTs',
    external: true,
  },
  reddit: {
    name: 'Reddit',
    link: 'https://www.reddit.com/r/energicryptocurrency/',
    external: true,
  },
  youtube: {
    name: 'Youtube',
    link: 'https://www.youtube.com/c/Energicrypto',
    external: true,
  },
  facebook: {
    name: 'Facebook',
    link: 'https://www.facebook.com/energicrypto/',
    external: true,
  },
  instagram: {
    name: 'Instagram',
    link: 'https://www.instagram.com/energicrypto',
    external: true,
  },
  linkedin: {
    name: 'Linkedin',
    link: 'https://www.linkedin.com/company/energi-core/',
    external: true,
  },
  aboutUs: {
    name: 'About Us',
    // link: 'https://www.gonnamakeit.com/',
    external: true,
  },
  terms: {
    name: 'Terms',
    link: 'tos',
  },
  docs: {
    name: 'Docs',
    link: LINK_GMI_DOCS,
    external: true,
  },
  developerDocs: {
    name: 'Developer Docs',
    link: `${LINK_GMI_DOCS}docs/developers/`,
    external: true,
  },
  faq: {
    name: 'FAQ',
    link: `${LINK_GMI_DOCS}docs/faq/`,
    external: true,
  },
  guides: {
    name: 'GMI Guides',
    link: `${LINK_GMI_DOCS}docs/guides/`,
    external: true,
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    link: 'https://gonnamakeit.com/privacy-policy/',
    external: true,
  },
};

// Social media links/icons for sidebar and mobile menu
export const SOCIAL_MEDIAS = [
  {
    ...LINKS_LIST['twitter'],
    icon: <MenuTwitterIcon />,
  },
  {
    ...LINKS_LIST['instagram'],
    icon: <MenuInstagramIcon />,
  },
  {
    ...LINKS_LIST['discord'],
    icon: <MenuDiscordIcon />,
  },
  {
    ...LINKS_LIST['reddit'],
    icon: <MenuRedditIcon />,
  },
  {
    ...LINKS_LIST['youtube'],
    icon: <MenuYouTubeIcon />,
  },
];

export const NAV_MENUS = [
  {
    id: 1,
    text: 'Collections',
    path: '/collections?type=top',
  },
  {
    id: 2,
    text: 'LP Bonds',
    path: 'https://gonnamakeit.com/lp-bonds',
    submenu: false,
    gradient: 'lp-bonds',
  },
  {
    id: 3,
    text: 'Portfolio',
    path: '/portfolio',
    submenu: false,
  },
  {
    id: 4,
    text: 'Activity',
    path: '/activity',
    submenu: false,
  },
  {
    id: 5,
    text: 'Airdrop',
    path: 'https://airdrop.gonnamakeit.com/',
    submenu: false,
  },
  {
    id: 6,
    text: 'Create',
    path: '/create',
    submenu: false,
    notShowInSideNav: true,
  },
  {
    id: 7,
    text: 'Resources',
    path: '',
    submenu: true,
  },
  {
    id: 8,
    text: 'Get GMI',
    path: 'https://gonnamakeit.com/get-gmi',
    submenu: false,
    isButton: true,
  },
];

// marketplace - options to sort listed cards
export const SORT_OPTIONS = [
  { name: 'Listed: Recent', value: 'lastListingTimestamp', direction: 'ascending' },
  { name: 'Listed: Oldest', value: 'lastListingTimestamp', direction: 'descending' },
  { name: 'Price: Lowest', value: 'price', direction: 'ascending' },
  { name: 'Price: Highest', value: 'price', direction: 'descending' },
];

// marketplace - options to display type of cards
export const ITEMS_OPTIONS = [
  { name: 'Items', value: 'All_items' },
  { name: 'Single items', value: 'Single_items' },
  { name: 'Bundles', value: 'Bundles' },
];

// price history - options to price history time duration
export const PRICE_HISTORY_OPTIONS = [
  '7 days',
  '14 days',
  '30 days',
  '60 days',
  '90 days',
  'Last year',
  'All time',
];

const day = 24 * 60 * 60; // A day in seconds
export const FETCH_PERIOD = {
  '7 days': 7 * day,
  '14 days': 14 * day,
  '30 days': 30 * day,
  '60 days': 60 * day,
  '90 days': 90 * day,
  'Last year': 365 * day,
  'All time': Date.now() / 1000, // 'all time' timestamp
};

// Filter option for sort by date in rankings
export const LAST_PERIOD_OPTIONS = {
  'Last 10 minutes': 600,
  'Last 1 hour': 3600,
  'Last 6 hours': 21800,
  'Last 24 hours': 86400,
  'Last 7 days': 604800,
  'Last 30 days': 2592000,
};

export const COLLECTION_VOLUMES_TIMEFRAMES = {
  'Last 1 hour': '1h',
  'Last 6 hours': '6h',
  'Last 24 hours': '24h',
  'Last 7 days': '7d',
  'Last 30 days': '30d',
};

export const DEFAULT_TIMEFRAME = '24h';

export const COLLECTIONS_COLUMNS = [
  { field: 'rank', label: '#', align: 'left' },
  { field: 'name', label: 'Collection', align: 'left' },
  { field: 'floorPrice', label: 'Floor Price' },
  { field: 'topBid', label: 'Top Bid' },
  { field: 'change24h', label: '1D Change' },
  { field: 'change7d', label: '7D Change' },
  { field: 'volume24h', label: '1D Volume' },
  { field: 'volume7d', label: '7D Volume' },
  { field: 'totalVolume', label: 'Total Volume' },
  { field: 'owners', label: 'Owners' },
  { field: 'circulatingSupply', label: 'Supply/Listed' },
];

export const SORT_NETWORKS = [
  // { value: 'overall', label: 'Overall' },
  { value: 'gmi', label: 'GonnaMakeIt' },
  // { value: 'opensea', label: 'OpenSea' },
];

// accordion details of account support
export const ACCOUNT_SUPPORT_ACCORDIONS = [
  {
    summary: 'General help',
    detail: (
      <span>
        Visit our{' '}
        <Link
          href={ENERGI_SUPPORT_LINK}
          target="_blank"
          rel="noopener noreferer"
          sx={{ lineHeight: '18px' }}
        >
          help center
        </Link>{' '}
        to learn how to get started with buying, selling, and creating.
      </span>
    ),
  },
  {
    summary: 'Contact GonnaMakeIt Support',
    detail: (
      <span>
        {"Can't find the answers you're looking for?"} <br />
        You can{' '}
        <Link
          href="https://discord.com/channels/398355554172534805/1157987899246137384"
          target="_blank"
          rel="noopener noreferer"
          sx={{ lineHeight: '18px' }}
        >
          submit a request
        </Link>{' '}
        here.
      </span>
    ),
  },
  {
    summary: 'Help with a compromised account',
    detail: (
      <span>
        If you believe your account has been compromised, let us know and we can lock your account.
        This will disable items in your wallet from being bought, sold, or transferred using
        GonnaMakeIt.{' '}
        <Link
          href={ENERGI_SUPPORT_LINK}
          target="_blank"
          rel="noopener noreferer"
          sx={{ lineHeight: '18px' }}
        >
          Learn more
        </Link>{' '}
        .
      </span>
    ),
  },
];

// compromised options for account support
export const COMPROMISED_OPTIONS = [
  { value: 1, text: 'I have unknown transactions on my account' },
  { value: 2, text: 'I have everything but believe my account is compromised' },
  { value: 3, text: 'Other' },
];

const iconTag = (ActivityIcon) => {
  return <ActivityIcon sx={{ width: 20, marginRight: 1, color: 'icon.secondary' }} />;
};

// Activity types for filter and display
export const ACTIVITY_TYPES = {
  sale: { name: 'Sale', icon: iconTag(SaleIcon) },
  listing: { name: 'List', icon: iconTag(ListIcon) },
  offer: { name: 'Offer', icon: iconTag(OfferIcon) },
  mint: { name: 'Mint', icon: iconTag(MintedIcon) },
  transfer: { name: 'Transfer', icon: iconTag(TransferIcon) },
  burn: { name: 'Burn', icon: iconTag(BurnIcon) },
  bid: { name: 'Bid', icon: iconTag(BidIcon) },
};

// Message to sign for authentication
export const AUTH_MESSAGE_TO_SIGN = (address, nonce) => {
  return `Welcome to GonnaMakeIt!\n\nClick to sign in and accept the GonnaMakeIt Terms of Service\n\nThis request will not trigger a blockchain transaction or cost any gas fees.\n\nYour authentication status will reset after 7 days.\n\nWallet address: ${address}\n\nNonce: ${nonce}`;
};

// marketplace - options to display features of card
export const CARD_OPTIONS = [
  { name: 'Refresh metadata', value: 'REFRESH_METADATA', item: 'nft' },
  { name: 'Copy link', value: 'COPY_LINK', item: 'nft' },
  { name: 'Website', value: 'WEBSITE', item: 'nft' },
  { name: 'Report this item', value: 'REPORT', item: 'nft' },
];

export const activityFilterStatusOpen = [
  { name: 'Status', active: false },
  { name: 'Collections', active: false },
];

export const CollectionFilterOpen = [
  { name: 'Status', active: false },
  { name: 'Collections', active: false },
];

export const REWARDS_TABS = [
  '/rewards/referral_program',
  '/rewards/referral_program/apply_promo',
  '/rewards/referral_program/redeem',
];

export const RESOURCE_MENU = [
  {
    text: 'Launchpad',
    path: DEFAULT_LAUNCHPAD,
  },
  {
    text: 'NFT Bridge',
    path: 'https://bridge.gonnamakeit.com/',
  },
  {
    text: 'For Investors',
    path: 'https://gonnamakeit.com/for-investors/',
  },
  /*{
    text: 'Rewards',
    path: '/rewards/referral_program',
    // submenus: REWARDS_MENU, TODO: Unhide when farming or listing is ready
    tabs: REWARDS_TABS,
  },*/
  {
    text: 'Help Center',
    path: ENERGI_SUPPORT_LINK,
  },
  /*{
    text: 'Referral stats',
    path: '/collections?type=referral',
  },*/
  {
    text: 'Energi Website',
    path: 'https://energi.world/',
  },
  {
    text: 'Docs',
    path: LINK_GMI_DOCS,
  },
];

// const AIRDROP_REFERRAL_WEBSITE = 'https://ref.gonnamakeit.com/referral';

/*export const REWARDS_MENU = [
  {
    text: 'Referral program',
    path: AIRDROP_REFERRAL_WEBSITE,
  },
  {
    text: 'Farming',
    path: '/rewards/farming',
  },
  {
    text: 'Listing rewards',
    path: '/rewards/listing-rewards',
  },
];*/

export const NAVBAR_MENUS = [
  {
    text: 'Collections',
    path: '/collections?type=top',
    tabs: ['/collections'],
  },
  {
    text: 'LP Bonds',
    path: 'https://gonnamakeit.com/lp-bonds',
  },
  {
    text: 'Portfolio',
    path: '/portfolio',
  },
  {
    text: 'Activity',
    path: '/activity',
  },
  {
    text: 'Airdrop',
    path: 'https://airdrop.gonnamakeit.com/',
  },
  {
    text: 'Resources',
    path: '',
    submenus: RESOURCE_MENU,
  },
  {
    text: 'Get GMI',
    path: 'https://gonnamakeit.com/get-gmi',
  },
];

export const STAT_SUB_NAVIGATIONS = [
  {
    text: 'Collections',
    link: 'top',
    icon: <CollectionIcon fontSize="13px" />,
  },
  /*
  * Hide for soft lunch:
  * https://git.energi.software/energi/tech/dweb/nft/marketplace/webapp/-/issues/491
  {
    text: 'Trending',
    link: 'trending',
  },
  */
  {
    text: 'Favorites',
    link: 'favorites',
    icon: <StarBorder sx={{ width: '20px', height: '20px' }} />,
  },
];

export const STAT_REWARDS_SUB_NAVIGATIONS = [
  {
    text: 'Referral rewards',
    link: 'referral',
  },
  {
    text: 'Airdrop referral rewards',
    link: 'airdrop',
  },
];

export const PAGE_SIZES = [100, 50, 20];

export const REPORT_OPTIONS = [
  { label: 'Fake collection or possible scam', value: 0 },
  { label: 'Explicit or sensitive content', value: 1 },
  { label: 'Spam', value: 2 },
  { label: 'Might be stolen', value: 3 },
  { label: 'Other', value: 4 },
];

export const RAW_COLLECTION = [
  {
    name: 'Crypto Punk',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
  {
    name: 'Energi Special',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
  {
    name: 'ABC Collection',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
  {
    name: 'Scoppy Do',
    active: false,
    show: true,
    alt: 'Avatar',
    src: 'https://i.pravatar.cc/300',
  },
]; // dummy data - Fetch from database

export const ACCOUNT_SETTINGS = [
  {
    slug: 'profile',
    icon: <ProfileIcon />,
    text: 'Profile',
    component: <Profile />,
    path: '/account/settings/profile',
  },
  /* TODO: enable when Notifications ready
  {
    slug: 'notifications',
    icon: <NotificationsIcon />,
    text: 'Notifications',
    component: <Notifications />,
    path: '/account/settings/notifications',
  },*/
  /* TODO: enable when Bids ready
  {
    slug: 'offers',
    icon: <LocalOfferIcon />,
    text: 'Offers',
    component: <Offers />,
    path: '/account/settings/offers',
  },*/
  {
    slug: 'collections',
    icon: <DashboardIcon />,
    text: 'My Collections',
    component: <MyCollections />,
    path: '/account/settings/collections',
  },
  {
    slug: 'account_support',
    icon: <SecurityIcon />,
    text: 'Account Support',
    component: <AccountSupport />,
    path: '/account/settings/support',
  },
];

export const FILTER_BOX_MAX_HEIGHT = 80;
export const DEFAULT_SIZE = 20;

// Chain-specific token mapping - defines which tokens are valid for each chain
export const CHAIN_TOKENS = {
  [SUPPORTED_NETWORKS.Ethereum]: ['ETH', 'WETH', 'GMI', 'GMICV', 'NRG'],
  [SUPPORTED_NETWORKS.Energi]: ['NRG', 'WNRG', 'ETH', 'WETH', 'GMICV', 'GMI'],
  [SUPPORTED_NETWORKS.Base]: ['ETH', 'WETH'],
  [SUPPORTED_NETWORKS.Soneium]: ['ETH', 'WETH'],
  [SUPPORTED_NETWORKS.Abstract]: ['ETH', 'WETH'],
  [SUPPORTED_NETWORKS.Ten]: ['ETH', 'WETH'],
  [SUPPORTED_NETWORKS.Shibarium]: ['BONE', 'WBONE'],
  [SUPPORTED_NETWORKS.ApeChain]: ['APE', 'WAPE', 'GMI'],
  [SUPPORTED_NETWORKS.Berachain]: ['BERA', 'WBERA'],
  [SUPPORTED_NETWORKS.Monad]: ['MON', 'WMON'],
};
// Global token list - all unique tokens across all chains
export const TOKEN_LIST = [...new Set(Object.values(CHAIN_TOKENS).flat())];

export const UNISWAP_V3_NFT_POSITION_MANAGER_CONTRACT =
  '0x1238536071E1c677A632429e3655c799b22cDA52';
export const GMICV_CONTRACT_ADDRESS = '0xc85d4367eB56dDc56E96A56E003A0514b41a70cE';
export const WETH_CONTRACT_ADDRESS = '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14';
export const GMICV_POOL_ADDRESS = '0x53f8887aa52F9B4cA9Ed323B4D56e9f489272c6a';

// Ethereum LP Bond Constants
export const GMI_TOKEN_ADDRESS = '0x044e874f23f9a7e5dad696554a116c4bb62fecb7';
export const ETHEREUM_GMI_TOKEN_ADDRESS = '0x044e874f23f9a7e5dad696554a116c4bb62fecb7';
export const ETHEREUM_HELLO_TOKEN_ADDRESS = '0x411099C0b413f4fedDb10Edf6a8be63BD321311C'; // HELLO token contract
export const ETHEREUM_USDT_TOKEN_ADDRESS = '0xdac17f958d2ee523a2206206994597c13d831ec7'; // USDT token on Ethereum mainnet
export const ETHEREUM_LP_BOND_LOCKER_PROXY = '0xa656327cafd497f98f8744a0cea3a17e0a7df4df';
export const ETHEREUM_HELLO_DEX_LP_BOND_LOCKER_PROXY = '0xff9Ce80Ecfdd2748B160520B3f033379f4a9E888'; // Hello DEX locker proxy
// Pair contracts for Hello DEX
export const ETHEREUM_GMI_HELLO_PAIR = '0xaf05a0f6cae12da1a1d5967938e6f44cf46e1099';
export const ETHEREUM_GMI_USDT_PAIR = '0x318161d4d892003479bcd8aec6319f6a5939fe98';

// Apechain LP Bond Constants
export const APECHAIN_GMI_TOKEN_ADDRESS = '0x044e874f23f9a7e5dad696554a116c4bb62fecb7';
export const APECHAIN_WAPE_TOKEN_ADDRESS = '0x48b62137edfa95a428d35c09e44256a739f6b557';
export const APECHAIN_APEUSD_TOKEN_ADDRESS = '0xa2235d059f80e176d931ef76b6c51953eb3fbef4';
export const APECHAIN_LP_BOND_LOCKER_PROXY = '0x2bac18cf8a0be7dbc89ca3d58909eb2bbbc55b10';

export const BALANCE_TOKEN_LIST = [
  {
    symbol: 'ETH',
    name: 'Ether',
    chains: [1, 11155111, 8453, 84532, 1868, 1946, 2741, 11124, 443],
    isNative: true,
    decimals: 18,
  },
  {
    symbol: 'NRG',
    name: 'Energi',
    decimals: 18,
    chains: [1, 11155111, 39797, 49797],
    isNative: true, // Native on Energi chains, ERC20 where addresses are specified
    addresses: {
      1: '0x1416946162b1c2c871a73b07e932d2fb6c932069', // NRG token on Ethereum mainnet
      11155111: '0xc85d4367eB56dDc56E96A56E003A0514b41a70cE', // NRG token on Sepolia testnet
      // No addresses for 39797, 49797 means it's native on those chains
    },
  },
  {
    symbol: 'WNRG',
    name: 'Wrapped Energi',
    chains: [39797, 49797],
    decimals: 18,
    isWrapped: true,
    addresses: {
      39797: '0xA55F26319462355474A9F2c8790860776a329aA4',
      49797: '0x184F7b12f29d675f34ff816528ADBfd0E0501Ad4',
    },
  },
  {
    symbol: 'WETH',
    name: 'Wrapped Ethereum',
    decimals: 18,
    chains: [1, 11155111, 8453, 84532, 1868, 1946, 2741, 11124, 443],
    addresses: {
      1: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      11155111: '0x7b79995e5f793a07bc00c21412e50ecae098e7f9',
      8453: '0x4200000000000000000000000000000000000006',
      84532: '0xea347a7cb535cbe125099a4c3b992149ae08e55d',
      1868: '0x4200000000000000000000000000000000000006',
      1946: '0x4200000000000000000000000000000000000006',
      2741: '0x3439153eb7af838ad19d56e1571fbd09333c2809',
      11124: '0x9edcde0257f2386ce177c3a7fcdd97787f0d841d',
      443: '0x0f4de42bd8a5effa57bcfc9cf842f96bf6cdbf26', // TEN Testnet WETH
      // TODO: Add TEN mainnet WETH address when available
    },
  },
  {
    symbol: 'MON',
    name: 'Monad',
    decimals: 18,
    chains: [10143], // Monad Testnet
    isNative: true,
  },
  {
    symbol: 'WMON',
    name: 'Wrapped Monad',
    decimals: 18,
    chains: [10143], // Monad Testnet
    addresses: {
      10143: '0x760afe86e5de5fa0ee542fc7b7b713e1c5425701', // Monad Testnet WMON
      // TODO: Add Monad mainnet WMON address when available
    },
  },
  {
    symbol: 'APE',
    name: 'ApeChain',
    decimals: 18,
    chains: [33139, 33111],
    isNative: true,
  },
  {
    symbol: 'WAPE',
    name: 'Wrapped ApeChain',
    decimals: 18,
    chains: [33139, 33111],
    addresses: {
      33139: '0x48b62137edfa95a428d35c09e44256a739f6b557',
      33111: '0x383b5827dde285761c7d8094bf974bea38bead43',
    },
  },
  {
    symbol: 'BERA',
    name: 'Berachain',
    decimals: 18,
    chains: [80094, 80069],
    isNative: true,
  },
  {
    symbol: 'WBERA',
    name: 'Wrapped Berachain',
    decimals: 18,
    chains: [80094, 80069],
    addresses: {
      80094: '0x6969696969696969696969696969696969696969',
      80069: '0x6969696969696969696969696969696969696969',
    },
  },
  {
    symbol: 'BONE',
    name: 'BONE',
    chains: [109, 157], // Shibarium chains
    isNative: true,
    decimals: 18,
  },
  {
    symbol: 'WBONE',
    name: 'Wrapped BONE',
    decimals: 18,
    chains: [109, 157], // Shibarium chains
    addresses: {
      109: '0x839FdB6cc98342B428E074C1573ADF6D48CA3bFd', // Shibarium mainnet WBONE address
      157: '0x41c3F37587EBcD46C0F85eF43E38BcfE1E70Ab56', // Puppynet testnet WBONE address
    },
  },
  {
    symbol: 'GMICV',
    name: 'Gonna Make It Collector Version',
    decimals: 18,
    chains: [1, 11155111],
    addresses: {
      1: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      11155111: '0xc85d4367eB56dDc56E96A56E003A0514b41a70cE',
    },
  },

  {
    symbol: 'GMI',
    name: 'GonnaMakeIt',
    decimals: 18,
    chains: [1, 33139, 33111], // Ethereum mainnet and ApeChain
    addresses: {
      1: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on Ethereum mainnet
      33139: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on ApeChain mainnet
      33111: '0x044e874f23f9a7e5dad696554a116c4bb62fecb7', // GMI token on ApeChain testnet (Curtis)
    },
  },
  {
    symbol: 'USDT',
    name: 'Tether USD',
    decimals: 6,
    chains: [1], // Ethereum mainnet only
    addresses: {
      1: '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT token on Ethereum mainnet
    },
  },
  {
    symbol: 'HELLO',
    name: 'Hello Labs',
    decimals: 18,
    chains: [1], // Ethereum mainnet only
    addresses: {
      1: '0x411099c0b413f4feddb10edf6a8be63bd321311c', // Hello Labs HELLO token on Ethereum mainnet
    },
  },
  {
    symbol: 'apeUSD',
    name: 'ApeChain USD',
    decimals: 18,
    chains: [33139, 33111], // ApeChain only
    addresses: {
      33139: '0xa2235d059f80e176d931ef76b6c51953eb3fbef4', // apeUSD on ApeChain mainnet
      33111: '0xa2235d059f80e176d931ef76b6c51953eb3fbef4', // apeUSD on ApeChain testnet (Curtis)
    },
  },
];

export const NETWORK_NAME = {
  1: 'Ethereum',
  11155111: 'Sepolia',
  39797: 'Energi',
  49797: 'Energi Testnet',
  8453: 'Base',
  84532: 'Base Sepolia',
  33139: 'ApeChain',
  33111: 'Curtis',
  80094: 'Berachain',
  80069: 'Bepolia',
  1868: 'Soneium',
  1946: 'Soneium Minato',
  2741: 'Abstract',
  11124: 'Abstract Testnet',
  109: 'Shibarium',
  157: 'Puppynet',
  443: 'TEN Testnet',
  10143: 'Monad Testnet',
  // TODO: Add TEN mainnet name when available
  // TODO: Add Monad mainnet name when available
  default: 'Default Network',
};

export const REDIRECT_LINK_EXPLORER = {
  1: 'https://etherscan.io',
  11155111: 'https://sepolia.etherscan.io',
  39797: 'https://explorer.energi.network',
  49797: 'https://explorer.test.energi.network',
  8453: 'https://basescan.org',
  84532: 'https://sepolia.basescan.org',
  33139: 'https://apescan.io/',
  33111: 'https://curtis.apescan.io/',
  80094: 'https://berascan.com',
  80069: 'https://bepolia.beratrail.io',
  1868: 'https://soneium.blockscout.com',
  1946: 'https://soneium-minato.blockscout.com',
  2741: 'https://abscan.org',
  11124: 'https://sepolia.abscan.org',
  109: 'https://shibariumscan.io',
  157: 'https://puppyscan.shib.io',
  443: 'https://tenscan.io',
  10143: 'https://testnet.monadexplorer.com',
  // TODO: Add TEN mainnet explorer URL when available
  // TODO: Add Monad mainnet explorer URL when available
  default: '',
};

export const LINKS = {
  twitter: 'https://twitter.com/',
  instagram: 'https://instagram.com/',
};

// List id for newsletter email list on sendgrid. Need to be sent with the post request
// Type: string
export const NEWSLETTER_EMAIL_LIST_ID = '18944388';

export const REPORT_TOAST_DURATION = 4000;

export const WRAPPED_PROXY_ADDRESS = {
  1: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  11155111: '0x7b79995e5f793a07bc00c21412e50ecae098e7f9',
  39797: '0xa55f26319462355474a9f2c8790860776a329aa4',
  49797: '0x184f7b12f29d675f34ff816528adbfd0e0501ad4',
  8453: '0x4200000000000000000000000000000000000006', // Base Mainnet
  84532: '0xea347a7cb535cbe125099a4c3b992149ae08e55d', // Base Sepolia
  33139: '0x48b62137edfa95a428d35c09e44256a739f6b557',
  33111: '0x383b5827dde285761c7d8094bf974bea38bead43',
  80094: '0x6969696969696969696969696969696969696969',
  80069: '0x6969696969696969696969696969696969696969',
  1868: '0x4200000000000000000000000000000000000006',
  1946: '0x4200000000000000000000000000000000000006',
  2741: '0x3439153eb7af838ad19d56e1571fbd09333c2809',
  11124: '0x9edcde0257f2386ce177c3a7fcdd97787f0d841d',
  109: '0x839FdB6cc98342B428E074C1573ADF6D48CA3bFd', // Shibarium mainnet WBONE address
  157: '0x41c3F37587EBcD46C0F85eF43E38BcfE1E70Ab56', // Puppynet testnet WBONE address
  443: '0x0f4de42bd8a5effa57bcfc9cf842f96bf6cdbf26', // TEN Testnet WETH address
  10143: '0x760afe86e5de5fa0ee542fc7b7b713e1c5425701', // Monad Testnet WMON address
  // TODO: Add TEN mainnet wrapped token address when available
  // TODO: Add Monad mainnet wrapped token address when available
};

// ExchangeProxy contract address - indexed by chainId
export const EXCHANGE_PROXY_ADDRESS = {
  1: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
  11155111: '0x69131badf12db01116251018cc1015d2ff7f4833',
  39797: '0x0D09CDb5901467FA531Aa7b1D8AC331Ab9f1F70B',
  49797: '0xc805369791fc642ff3fc624b8edfa28b7e15701f',
  8453: '0x4E992E34dF70a3A903408Da308BDC1349277B6CD', // Base Mainnet
  84532: '0x44eb1be12d296a52bdeee7a55479771a4799d7e7', // Base Sepolia
  33139: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
  33111: '0x253ce8fd3031536e235682d1bde500aeab4bd2a7',
  80094: '0xd0e09207b1fab3ac21ef640e9b27cb6b7912d495',
  80069: '0xd0e09207b1fab3ac21ef640e9b27cb6b7912d495',
  1868: '0x4e992e34df70a3a903408da308bdc1349277b6cd',
  1946: '0x699137bf89e9b4af7ecb503aeac8f7e41536657a',
  2741: '0x8ec899a855a264b7f9c605f327a5f359d3fc1c2c',
  11124: '0x01e6dd3d7091ddc90a9af2165fb6073b417318c2',
  109: '0x1f6be490fab41545878ef1e4eb378d216241973f',
  157: '0x2c2e461ea3765f0cd78ef36930a5a9d77799dfda',
  443: '0x6647a0906dbd029dd1d119de28eb8f64542979e0', // TEN Testnet
  10143: '0x253ce8fd3031536e235682d1bde500aeab4bd2a7', // Monad Testnet
  // TODO: Add TEN mainnet exchange proxy address when available
  // TODO: Add Monad mainnet exchange proxy address when available
};

export const EXCHANGE_HELPER_PROXY_ADDRESS = {
  1: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
  11155111: '0x151448374ce04cab1bc2737c9ada6b6fcc71cf7e',
  39797: '0xA46c1A4f05609C36F0389d6fC2cEB2e5aE86b487',
  49797: '0x5d4808a0da3a2aad2315f9cdfc4a667fbb3bb68c',
  8453: '0xA46c1A4f05609C36F0389d6fC2cEB2e5aE86b487', // Base Mainnet
  84532: '0x189b22e18626171bc9290878dbd80f62764145c1', // Base Sepolia
  33139: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
  33111: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1',
  80094: '0xc857610831aeb89c9087e5745b77da9160c3eb68',
  80069: '0xc857610831aeb89c9087e5745b77da9160c3eb68',
  1868: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
  1946: '0x6647a0906dbd029dd1d119de28eb8f64542979e0',
  2741: '0x2c337e5e9fcc637c36f902e9d4311c63b763687b',
  11124: '0x7acfdf0817f5ba7cd9832562f34a72d448e92fc7',
  109: '0x4c579275d6f383ad0c8f67e584bec89033eee62d',
  157: '0x7829b72c00b623d1d34edb3afbc2f7ce453af4e2',
  443: '0xb6c7263db9713e9b3bf8196729d1b855d989cfff', // TEN Testnet
  10143: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1', // Monad Testnet
  // TODO: Add TEN mainnet exchange helper address when available
  // TODO: Add Monad mainnet exchange helper address when available
};

export const GMI_GOERLI_TOKENS = {
  address: '0xCE6C188582b65560F64DBE86cd0E760C0cf088fC',
  chainId: 5,
  decimals: 18,
  logo: 'assets/images/NRGLogoDark.svg',
  name: 'GonnaMakeIt',
  symbol: 'GMI',
};

export const GMI_TOKEN_DETAILS = {
  Mainnet: {
    address: '0xCE6C188582b65560F64DBE86cd0E760C0cf088fC',
    symbol: 'GMI',
    decimals: 18,
    image: 'https://explorer.energi.network/images/tokens/NRG.svg',
  },
  Testnet: {
    address: '0xCE6C188582b65560F64DBE86cd0E760C0cf088fC',
    symbol: 'GMI',
    decimals: 18,
    image: 'https://explorer.energi.network/images/tokens/NRG.svg',
  },
};

export const SUSHISWAP_GMI =
  'https://app.sushi.com/swap?inputCurrency=ETH&outputCurrency=0xCE6C188582b65560F64DBE86cd0E760C0cf088fC&chainId=5';

export const ETHERSCAN_ENERGI =
  'https://etherscan.io/token/0x1416946162b1c2c871a73b07e932d2fb6c932069';

export const POOLS_COUNT = 7;

export const NetworkContextName = 'NETWORK';

export const FARMING_PROXY_ADDRESS = {
  Mainnet: {
    '6 Months': '0xe09F8a908F9ECB6aD7232608D3d9cf8732bE506f',
    '1 Year': '0x378651f2f17dBDCC2D2a704C5b6ec88f995FF33d',
    '2 Years': '0xC54fEc8965567b0E624D735fcd0Bf921cD8A2565',
    '3 Years': '0x2442176111629b18e4E3ae68B2999595D023B535',
    '5 Years': '0x2b7902724e749c304CE90a8B2E093a5157A94026',
  },
  Testnet: {
    '6 Months': '0xe09F8a908F9ECB6aD7232608D3d9cf8732bE506f',
    '1 Year': '0x378651f2f17dBDCC2D2a704C5b6ec88f995FF33d',
    '2 Years': '0xC54fEc8965567b0E624D735fcd0Bf921cD8A2565',
    '3 Years': '0x2442176111629b18e4E3ae68B2999595D023B535',
    '5 Years': '0x2b7902724e749c304CE90a8B2E093a5157A94026',
  },
};

// TODO: Doris suggested to Brian about renaming this to "GMI-WETH LP Token SushiSWAP"
export const FARMING_ADDRESS = {
  Mainnet: '0xeE39CFd750A6fa5b4c06C2600e20782602278f7F',
  Testnet: '0xeE39CFd750A6fa5b4c06C2600e20782602278f7F',
};

// ExchangeProxy contract asset classes
export const CONTRACT_ASSET_CLASSES = {
  C_ETH: -1161908566,
  C_ETH_STR: '0xaaaebeba',
  C_WETH: 260708671,
  C_WETH_STR: '0x0f8a193f',
  C_ERC20: -2074220406,
  C_ERC20_STR: '0x8ae85d84',
  C_ERC721: 1176612211,
  C_ERC721_STR: '0x73ad2146',
  C_ERC1155: 1085684631,
  C_ERC1155_STR: '0x973bb640',
  C_V1: 1715610444,
  C_V1_STR: '0x6642234c',
  C_ff: -1,
  C_ff_STR: '0xffffffff',
};

// Zero address
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
// Dead address
export const DEAD_ADDRESS = '0x000000000000000000000000000000000000dead';

// EIP712 signer message
export const EIP712_SIGNER_MESSAGE = {
  types: {
    AssetType: [
      { name: 'assetClass', type: 'bytes4' },
      { name: 'data', type: 'bytes' },
    ],
    Asset: [
      { name: 'assetType', type: 'AssetType' },
      { name: 'value', type: 'uint256' },
    ],
    Order: [
      { name: 'maker', type: 'address' },
      { name: 'makeAsset', type: 'Asset' },
      { name: 'taker', type: 'address' },
      { name: 'takeAsset', type: 'Asset' },
      { name: 'salt', type: 'uint256' },
      { name: 'start', type: 'uint256' },
      { name: 'end', type: 'uint256' },
      { name: 'dataType', type: 'bytes4' },
      { name: 'data', type: 'bytes' },
      { name: 'collectionBid', type: 'bool' },
    ],
  },
  primaryType: 'Order',
  domain: {
    name: 'Energi',
    version: '1',
    chainId: 0, // current network chain id
    verifyingContract: '', // contract that will verify signature
  },
  message: '', // maker order
};

export const RETRY_COUNT = 120; // Number of times called getTransactionRecipt function

export const SLEEP_INTERVAL = 1000; //

export const MAX_GAS_ALLOWANCE = BigInt(3500000);

export const MAX_APPROVAL_AMOUNT =
  '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';

export const FARMING_POOL_TIME = [
  { duration: '6 Months', duration_short: '6M' },
  { duration: '1 Year', duration_short: '1Y' },
  { duration: '2 Years', duration_short: '2Y' },
  { duration: '3 Years', duration_short: '3Y' },
  { duration: '5 Years', duration_short: '5Y' },
];

export const TABS = [
  {
    text: 'Claimable',
  },
  {
    text: 'Pending',
  },
];

// This contract has the same address on all testnets.
export const SUSHISWAP_ROUTER_ADDRESS = {
  Mainnet: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
  Testnet: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
};

export const FARMING_POOL_EST_APY = {
  '6 Months': '30%',
  '1 Year': '80%',
  '2 Years': '400%',
  '3 Years': '1000%',
  '5 Years': '5000%',
};

export const SOCIAL_MEDIA_COLORS = {
  Twitter: '#1DA1F2',
  Reddit: '#FF5700',
  Facebook: '#4267B2',
  WhatsApp: '#25D366',
};

export const RESEND_EMAIL_VERIFICATION_DELAY = 60000; // 1 minute in milliseconds
export const LOCAL_STORAGE_TIMER_KEY = 'timerData';

export const ACTIVE_STEPS = {
  CALL_APPROVE: 0,
  INTERACT_METAMASK_APPROVE: 1,
  CONFIRM_TRANSACTION_APPROVE: 2,
  CALL_FUNCTION: 3,
  COMPLETE_TRANSACTION: 4,
};

export const AIRDROP_REWARDS = {
  AVAILABLE: '--',
  CLAIMED: '--',
  BONUS_AVAILABLE: '--',
  BONUS_CLAIMED: '--',
};

export const SUPPORT_EMAIL = 'support@gonnamakeit.com';

export const NETWORK = {
  1: {
    name: 'Ethereum',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
    maxDecimals: 4,
    minAmount: 0.0001,
  },
  11155111: {
    name: 'Sepolia',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0x151448374ce04cab1bc2737c9ada6b6fcc71cf7e',
    maxDecimals: 4,
    minAmount: 0.0001,
  },
  39797: {
    name: 'Energi Mainnet',
    symbol: 'NRG',
    wrapped: 'WNRG',
    exchange_address: '0xA46c1A4f05609C36F0389d6fC2cEB2e5aE86b487',
    maxDecimals: 2,
    minAmount: 1,
  },
  49797: {
    name: 'Energi Testnet',
    symbol: 'NRG',
    wrapped: 'WNRG',
    exchange_address: '0x5d4808a0da3a2aad2315f9cdfc4a667fbb3bb68c',
    maxDecimals: 2,
    minAmount: 1,
  },
  8453: {
    name: 'Base',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0xA46c1A4f05609C36F0389d6fC2cEB2e5aE86b487', // Base Mainnet
    maxDecimals: 4,
    minAmount: 0.0001,
  },
  84532: {
    name: 'Base Sepolia',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0x189b22e18626171bc9290878dbd80f62764145c1', // Base Testnet
    maxDecimals: 4,
    minAmount: 0.0001,
  },
  33139: {
    name: 'ApeChain',
    symbol: 'APE',
    wrapped: 'WAPE',
    exchange_address: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
    maxDecimals: 4,
  },
  33111: {
    name: 'Curtis',
    symbol: 'APE',
    wrapped: 'WAPE',
    exchange_address: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1',
    maxDecimals: 4,
  },
  80094: {
    name: 'Berachain',
    symbol: 'BERA',
    wrapped: 'WBERA',
    exchange_address: '0xc857610831aeb89c9087e5745b77da9160c3eb68',
    maxDecimals: 4,
  },
  80069: {
    name: 'Bepolia',
    symbol: 'BERA',
    wrapped: 'WBERA',
    exchange_address: '0xc857610831aeb89c9087e5745b77da9160c3eb68',
    maxDecimals: 4,
  },
  1868: {
    name: 'Soneium',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0xa46c1a4f05609c36f0389d6fc2ceb2e5ae86b487',
    maxDecimals: 4,
  },
  1946: {
    name: 'Soneium Minato',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0x6647a0906dbd029dd1d119de28eb8f64542979e0',
    maxDecimals: 4,
  },
  2741: {
    name: 'Abstract',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0x2c337e5e9fcc637c36f902e9d4311c63b763687b',
    maxDecimals: 4,
  },
  11124: {
    name: 'Abstract Testnet',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0x7acfdf0817f5ba7cd9832562f34a72d448e92fc7',
    maxDecimals: 4,
  },
  109: {
    name: 'Shibarium',
    symbol: 'BONE',
    wrapped: 'WBONE',
    exchange_address: '0x435f2f5c023c0dd22f818e1617bc1b7030a4f8ab', // TODO: Replace with Shibarium mainnet exchange address
    maxDecimals: 4,
  },
  157: {
    name: 'Puppynet',
    symbol: 'BONE',
    wrapped: 'WBONE',
    exchange_address: '0xd9600e27a21e25FB33802e6467d45A5F62900', // Puppynet testnet ExchangeProxy
    maxDecimals: 4,
  },
  443: {
    name: 'TEN Testnet',
    symbol: 'ETH',
    wrapped: 'WETH',
    exchange_address: '0xb6c7263db9713e9b3bf8196729d1b855d989cfff', // TEN Testnet ExchangeHelper
    maxDecimals: 4, // Follow ETH standard
    minAmount: 0.0001,
  },
  10143: {
    name: 'Monad Testnet',
    symbol: 'MON',
    wrapped: 'WMON',
    exchange_address: '0x1a40ac86bff0cfefac5ffa64acfa913887faf1f1', // Monad Testnet ExchangeHelper
    maxDecimals: 2, // 2 decimals as specified in requirements
    minAmount: 1,
  },
  // TODO: Add TEN mainnet configuration when available
  // TODO: Add Monad mainnet configuration when available
};

export const NETWORK_DEFAULT = NETWORK[DEFAULT_NETWORK];

// Files
export const FILE_MAX_SIZE = 10 * 1024 * 1024; // 10 MB

export const TOTAL_ROYALTY_PERCENTAGE = {
  MIN: 0.5,
  MAX: 7,
  MULTIPLIER: 100,
};

export const DECIMALS_REGEX = /-?\d*\.?\d{0,3}/i;

export const COLLECTION_VIEWS = [
  { value: 'condensed', icon: <MuiListIcon /> },
  { value: 'expanded', icon: <FormatListBulletedIcon /> },
];

export const SINGLE_COLLECTION = {
  FETCH_RESULT_LIMIT: 50,
  DEFAULT_VIEW: 'BigThumbnail',
  CONTENT_VIEWS: {
    ShortList: <MuiListIcon />,
    LargeList: <FormatListBulletedIcon />,
    SmallThumbnail: <AppsIcon />,
    BigThumbnail: <WindowIcon />,
  },
  MOBILE_CONTENT_VIEWS: {
    LargeList: <FormatListBulletedIcon />,
    SmallThumbnail: <AppsIcon />,
    BigThumbnail: <WindowIcon />,
    LargeThumbnail: <LargeBoxIcon sx={{ fontSize: 26 }} />,
  },
  CONTENT_TABS: {
    ITEMS_TAB: {
      icon: <ItemsIcon fontSize="small" />,
      label: 'Items',
      value: 0,
    },
    BIDS_TAB: {
      icon: <BidsIcon fontSize="large" />,
      label: 'Bids',
      value: 1,
    },
    ANALYTICS_TAB: {
      icon: <AnalyticsIcon fontSize="small" />,
      label: 'Analytics',
      value: 2,
    },
    ACTIVITY_TAB: {
      icon: <ActivityIcon fontSize="small" />,
      label: 'Activity',
      value: 3,
    },
    HOLDERS_TAB: {
      icon: <HoldersIcon fontSize="small" />,
      label: 'Holders',
      value: 4,
    },
  },
};

export const ACTIVITY_TABLE_COLUMNS = [
  {
    field: 'activity',
    label: 'Event',
    sx: { position: 'sticky', left: 0, zIndex: 5, pl: 0 },
  },
  { field: 'item', label: 'Item' },
  { field: 'price', label: 'Price', sx: { textAlign: 'right' } },
  { field: 'from', label: 'From', sx: { pl: 6, textAlign: 'right' } },
  { field: 'to', label: 'To', sx: { textAlign: 'right' } },
  { field: 'time', label: 'Time', sx: { textAlign: 'right' } },
];

export const LISTING_DURATIONS = [
  {
    key: '1 Hour',
    value: 1,
  },
  {
    key: '1 Day',
    value: 1 * 24,
  },
  {
    key: '3 Days',
    value: 3 * 24,
  },
  {
    key: '7 Days',
    value: 7 * 24,
  },
  {
    key: '30 Days',
    value: 30 * 24,
  },
  {
    key: '6 Months',
    value: 180 * 24,
  },
];

export const RARITIES_PERCENTILE = {
  mythic: 'Top 1%',
  legendary: 'Top 3%',
  epic: 'Top 10%',
  rare: 'Top 25%',
  uncommon: 'Top 50%',
  common: 'Bottom 50%',
};

export const PORTFOLIO_FILTER = ['Show All', 'Only Listed'];

export const PORTFOLIO_TABS = {
  Items: 'Items',
  Activity: 'Activity',
  Offers: 'Offers',
  Bids: 'Bids',
};

export const ORDER_TYPES = {
  LISTING: 'listing',
  OFFER: 'offer',
};

export const SOMETHING_WENT_WRONG = 'Something went wrong. Please try again later';

export const CATEGORY_OPTIONS = ['Art', 'Gaming', 'Membership', 'PFPs', 'Photography', 'Music'];

export const SOCIAL_LINKS = [
  {
    name: 'twitterUsername',
    adornment: 'https://x.com/',
    placeholder: 'my-first-collection',
    icon: <X />,
  },
  {
    name: 'instagramUsername',
    adornment: 'https://www.instagram.com/',
    placeholder: 'my-first-collection',
    icon: <Instagram />,
  },
  {
    name: 'discordUrl',
    placeholder: 'https://discord.gg/handle',
    icon: <DiscordNewIcon color="#929292" />,
  },
  { name: 'externalUrl', placeholder: 'https://yoursite.xyz', icon: <Language /> },
];

/**
 * The maximum number of NFTs that can be processed in a single transaction.
 * due to 40_000_000 max chain gas limit
 */
export const MAXIMUM_NFT_LIMIT = {
  // 1 mint is around 200_000 to 300_000 gas
  MINTS: 260,
  // 1 sweep item is around 600_000 to 700_000 gas
  SWEEPS: 60,
  // 1 bid item is around 850_000 to 950_000 gas
  BIDS: 40,
};

export const WALLET_OPTIONS = [
  {
    name: 'MetaMask',
    icon: <MetamaskIcon />,
  },
  {
    name: 'Coinbase Wallet',
    icon: <CoinBaseIcon />,
  },
];

export const MAX_FILE_SIZE = {
  label: '10 MB',
  value: 10 * 1024 * 1024,
};

export const METAMASK_DOWNLOAD_URL = 'https://metamask.io/download.html';

export const METAMASK_GUIDE_URL =
  'https://wiki.energi.world/docs/quickstart/getting-started-with-metamask';

const ALL_NETWORKS = [
  {
    value: SUPPORTED_NETWORKS.Energi,
    label: 'Energi',
    icon: <NRGChromeIcon />,
  },
  {
    value: SUPPORTED_NETWORKS.Ethereum,
    label: 'Ethereum',
    icon: <EthNewIcon />,
  },
  {
    value: SUPPORTED_NETWORKS.ApeChain,
    label: 'ApeChain',
    icon: <ApeChainSymbolNew sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Berachain,
    label: 'Berachain',
    icon: <BerachainSymbolNew sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Soneium,
    label: 'Soneium',
    icon: <SoneiumSymbol sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Base,
    label: 'Base',
    icon: <BaseSymbol />,
  },
  {
    value: SUPPORTED_NETWORKS.Abstract,
    label: 'Abstract',
    icon: <AbstractSymbol sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Shibarium,
    label: 'Shibarium',
    icon: <ShibariumSymbolNew sx={{ padding: '4px' }} />,
  },
  {
    value: SUPPORTED_NETWORKS.Ten,
    label: 'TEN',
    icon: (
      <TenSymbol src={require('assets/images/tenChain.jpg')} alt="TEN" sx={{ padding: '4px' }} />
    ),
  },
  {
    value: SUPPORTED_NETWORKS.Monad,
    label: 'Monad',
    icon: <MonadSymbol sx={{ padding: '4px' }} />,
  },
];

// Filter out TEN and Monad chains in mainnet mode since they don't have mainnet support yet
export const NETWORK_SELECTION =
  BUILD_MODE === 'Mainnet'
    ? ALL_NETWORKS.filter(
        (network) =>
          network.value !== SUPPORTED_NETWORKS.Ten && network.value !== SUPPORTED_NETWORKS.Monad,
      )
    : ALL_NETWORKS;

export const RESERVOIR_GMI_DOMAIN = 'app.gonnamakeit.com';

export const RESERVOIR_CHAINS = {
  1: reservoirChains.mainnet,
  11155111: reservoirChains.sepolia,
  8453: reservoirChains.base,
  84532: reservoirChains.baseSepolia,
  33139: reservoirChains.apechain,
  33111: reservoirChains.curtis,
  80094: reservoirChains.berachain,
  80069: reservoirChains.berachainTestnet,
  1868: reservoirChains.soneium,
  1946: reservoirChains.minato,
  2741: reservoirChains.abstract,
  11124: reservoirChains.abstractTestnet,
  10143: reservoirChains.monadTestnet, // Monad Testnet
  // TODO: Add Monad mainnet when available
};

export const RESERVOIR_CHAINS_LIST = [
  1, // Ethereum
  11155111, // Sepolia
  8453, // Base Mainnet
  84532, // Base Sepolia (Testnet)
  33139, // ApeChain
  33111, // Curtis
  80094, // Berachain
  80069, // Bepolia
  1868, // Soneium
  1946, // Soneium Minato
  2741, // Abstract
  11124, // Abstract Testnet
  10143, // Monad Testnet
  // TODO: Add Monad mainnet when available
];

export const ENERGI_CHAINS = [49797, 39797];
export const SHIBARIUM_CHAINS = [109, 157]; // Shibarium mainnet and Puppynet testnet
export const TEN_CHAINS = [443]; // TEN testnet only for now
// TODO: Add TEN mainnet chain ID when available

const ALL_CHAIN_NAME_DETAILS = {
  Testnet: {
    ethereum: {
      name: 'Sepolia',
      chainId: 11155111,
    },
    energi: {
      name: 'Energi Testnet',
      chainId: 49797,
    },
    base: {
      name: 'Base Sepolia',
      chainId: 84532,
    },
    apechain: {
      name: 'Curtis',
      chainId: 33111,
    },
    berachain: {
      name: 'Bepolia',
      chainId: 80069,
    },
    soneium: {
      name: 'Soneium Minato',
      chainId: 1946,
    },
    abstract: {
      name: 'Abstract Testnet',
      chainId: 11124,
    },
    shibarium: {
      name: 'Puppynet',
      chainId: 157,
    },
    ten: {
      name: 'TEN Testnet',
      chainId: 443,
    },
    monad: {
      name: 'Monad Testnet',
      chainId: 10143,
    },
  },
  Mainnet: {
    ethereum: {
      name: 'Ethereum',
      chainId: 1,
    },
    energi: {
      name: 'Energi Mainnet',
      chainId: 39797,
    },
    base: {
      name: 'Base',
      chainId: 8453,
    },
    apechain: {
      name: 'ApeChain',
      chainId: 33139,
    },
    berachain: {
      name: 'Berachain',
      chainId: 80094,
    },
    soneium: {
      name: 'Soneium',
      chainId: 1868,
    },
    abstract: {
      name: 'Abstract',
      chainId: 2741,
    },
    shibarium: {
      name: 'Shibarium',
      chainId: 109,
    },
    // TODO: Add TEN mainnet when chain ID becomes available
    /*ten: {
      name: 'TEN Mainnet',
      chainId: 443,
    },*/
    // TODO: Add Monad mainnet when chain ID becomes available
    /*monad: {
      name: 'Monad Mainnet',
      chainId: 999,
    },*/
  },
};

export const CHAIN_NAME_DETAILS = ALL_CHAIN_NAME_DETAILS[BUILD_MODE];

export const COLLECTION_VOLUME_MAX_DECIMAL = {
  39797: 0, // Energi
  49797: 0, // Energi Testnet
  1: 3, // Ethereum
  11155111: 3, // Sepolia
  8453: 3, // Base - matches Ethereum since it uses ETH
  84532: 3, // Base Sepolia - matches Ethereum since it uses ETH
  33139: 2, // ApeChain
  33111: 2, // Curtis
  80094: 2, // Berachain
  80069: 2, // Bepolia
  1868: 3, // Soneium - matches Ethereum since it uses ETH
  1946: 3, // Soneium Minato - matches Ethereum since it uses ETH
  2741: 3, // Abstract - matches Ethereum since it uses ETH
  11124: 3, // Abstract Testnet - matches Ethereum since it uses ETH
  109: 2, // Shibarium - similar to other alt chains
  157: 2, // Puppynet - similar to other alt chains
  443: 4, // TEN Testnet - matches Ethereum since it uses ETH
  10143: 2, // Monad Testnet - 2 decimals as specified in requirements
  // TODO: Add TEN mainnet volume decimal configuration
  // TODO: Add Monad mainnet volume decimal configuration
};

const ClockHeadingIcon = styled(AccessTimeIcon)(() => ({
  verticalAlign: 'middle',
  width: 20,
  height: 20,
}));

export const LIST_TABLE_COLUMNS = [
  { id: 'item', label: 'Item' },
  { id: 'rarity', label: 'Rarity', props: { textAlign: 'right' } },
  { id: 'buyNow', label: 'Buy Now', props: { textAlign: 'right' } },
  { id: 'lastSale', label: 'Last Sale', props: { textAlign: 'right' } },
  { id: 'owner', label: 'Owner', props: { textAlign: 'right' } },
  {
    id: 'time',
    label: (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ClockHeadingIcon />
      </Box>
    ),
    props: { textAlign: 'right' },
  },
];

export const LIST_TABLE_BOND_COLUMNS = [
  { id: 'item', label: 'Bond ID', type: 'bondId', props: { textAlign: 'left' } },
  { id: 'price', label: 'Price', type: 'price', props: { textAlign: 'right' } },
  { id: 'bid', label: 'Bid', type: 'bid', props: { textAlign: 'right' } },
  {
    id: 'rewardsAccrued',
    label: 'Rewards Accrued',
    type: 'rewards',
    props: { textAlign: 'right' },
  },
  { id: 'tvl', label: 'TVL', type: 'tvl', props: { textAlign: 'right' } },
  { id: 'apy', label: 'APY', type: 'apy', props: { textAlign: 'right' } },
  { id: 'duration', label: 'Duration', type: 'duration', props: { textAlign: 'right' } },
  {
    id: 'durationLeft',
    label: (
      <div>
        <ClockHeadingIcon key="TimeIcon" /> Left
      </div>
    ),
    type: 'left',
    props: { textAlign: 'right' },
  },
  { id: 'holders', label: 'Holders', type: 'holders', props: { textAlign: 'right' } },
];
